import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { ServiceProductCode, useProductAwenturesViewQuery } from "../../graphql/schema";
import { hasAvailableOffers } from "../../services/hasAvailableOffers";
import { notUndefinedOrNull } from "../../services/notUndefinedOrNull";
import { translateProductName } from "../../services/translateProductName";
import NotFoundView from "../not-found-view/NotFoundView";
import { ProductOasisAcademyBannerSection } from "./banner-section/ProductOasisAcademyBannerSection";
import { ProductOasisAcademyIntroSection } from "./intro-section/ProductOasisAcademyIntroSection";

export const ProductOasisAcademyView: React.FC = () => {
  const { data, loading, called } = useProductAwenturesViewQuery({
    variables: { productCodes: [ServiceProductCode.OASIS_ACADEMY] },
  });
  const { t } = useTranslation();

  // check what product is selected
  const [selectedOasisAcademyProductCode, setSelectedOasisAcademyProductCode] = useState<ServiceProductCode>(
    ServiceProductCode.OASIS_ACADEMY,
  );

  const products = (data?.services ?? [])
    .map((product) => {
      const offer = product && product.offers.length > 0 ? product?.offers[0] : undefined;

      if (!product || !offer) {
        return null;
      }

      return {
        ...offer,
        name: translateProductName(product, t) ?? product.name,
        value: product.code,
        currencyCode: offer.currency.code,
      };
    })
    .filter(notUndefinedOrNull);

  const selectedProduct = products.find((p) => p.value === selectedOasisAcademyProductCode);
  if (!loading && called && !hasAvailableOffers(products)) {
    return (
      <NotFoundView text={t("Product not available, you will be redirected back to homepage after few seconds...")} />
    );
  }

  return (
    <>
      <ProductOasisAcademyBannerSection
        productCode={selectedOasisAcademyProductCode}
        options={products}
        onOptionChange={setSelectedOasisAcademyProductCode}
      />

      <ProductOasisAcademyIntroSection productCode={selectedOasisAcademyProductCode} product={selectedProduct} />
    </>
  );
};
